import src from "IMAGE";
export default { src, width: 63, height: 14, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
